

































































































import { buildAbsoluteSpaPathForRedirect } from '@spa/router/hooks/lib/build-absolute-spa-path-for-redirect'
import { Mixins } from 'vue-mixin-decorator'
import { Component, Prop } from 'vue-property-decorator'

import ToSubscribePaidMemberButton from '@/components/molecules/paid-membership/ToSubscribePaidMemberButton.vue'
import BehaviorConfig from '@/models/app-config/behavior/behavior'
import ShippingFee from '@/models/shipping-fee'
import { formatPrice } from '@/util/format'

import { HavingPreSalesItemsState } from '@spa/components/pages/cart/model/Cart'
import {
  MembershipPlanPromotion,
  MembershipPlanPromotionPolicy,
  NoMembershipPlanPromotion,
} from '@spa/components/pages/cart/model/membership-promotion/promotion-policy'
import { Status } from '@spa/mixins/loading'
import { PluginMixin } from '@spa/mixins/plugin'

@Component({
  components: {
    ToSubscribePaidMemberButton,
  },
})
export default class CartHeader extends Mixins<PluginMixin>(PluginMixin) {
  @Prop({ required: true })
  loadingStatus: Status

  @Prop()
  isCartIn: boolean

  @Prop()
  totalItemCount: number

  @Prop({ required: true })
  totalCartPrice: number

  @Prop({ default: 0 })
  discountPrice: number

  @Prop({ required: true })
  behavior: BehaviorConfig

  @Prop({ default: false })
  isFreeShipping: boolean

  @Prop({ default: HavingPreSalesItemsState.None })
  havingPreSalesItemsState: HavingPreSalesItemsState

  @Prop({ required: true })
  fixedShippingFee: ShippingFee

  @Prop({ required: true })
  membershipPlanPromotionPolicy: MembershipPlanPromotionPolicy

  get isLoading(): boolean {
    return this.loadingStatus === Status.Loading
  }

  get isCompleted(): boolean {
    return this.loadingStatus === Status.Completed
  }

  get isFailed(): boolean {
    return this.loadingStatus === Status.Failed
  }

  get totalPrice(): number {
    return this.totalCartPrice - this.discountPrice
  }

  get remainingPriceForFreeShippingMessage(): string | null {
    if (!this.behavior.cart.promotion.freeShipping.show) {
      return null
    }

    /**
     * 合計金額は合計金額で表示しつつ、ユーザーに対する「あと〜X円で送料無料」のメッセージは通常注文のみを基準として表示する.
     * 送料無料の計算は注文ごとに行う.
     * 予約注文であっても、その注文の金額次第では送料無料になる.
     *
     * FIXME:
     * Cart.shouldShowRecommendItems とで
     * 「送料無料までの計算基準には、送料無料対象外の商品のみを用いる」
     * という知識が分散している
     *
     * @see https://github.com/my-color/front/issues/536
     * @see https://my-color.esa.io/posts/362
     */
    if (
      this.isFreeShipping ||
      this.havingPreSalesItemsState === HavingPreSalesItemsState.All
    ) {
      return null
    }

    const remainingPriceUntilFreeShipping = this.fixedShippingFee.remainingPriceUntilFreeShipping()

    if (!remainingPriceUntilFreeShipping) {
      return null
    }

    const defaultMessage = `あと<span class="p-cart-header-item__free-shipping__price">
      ${formatPrice(remainingPriceUntilFreeShipping)}</span>で送料無料です！`

    if (this.havingPreSalesItemsState === HavingPreSalesItemsState.Included) {
      return `${defaultMessage}<br>(※カートに入っている予約商品は、通常商品と配送時期が異なるため、送料無料の対象とならない場合がありますのでご注意ください)`
    }

    return defaultMessage
  }

  get membershipPlanPromotion(): MembershipPlanPromotion | NoMembershipPlanPromotion {
    return this.membershipPlanPromotionPolicy.promotion
  }

  get redirectAfterSubscribe(): string {
    return buildAbsoluteSpaPathForRedirect(this.$route.fullPath)
  }

  formatPrice(price: number): string {
    return formatPrice(price)
  }
}
